import gql from 'graphql-tag';

const saveMember = gql`
mutation saveMember($member: MemberInput) {
  saveMember(input: $member) {
    id
    personId
    firstName
    middleName
    lastName
    phoneNumber
    addressLine1
    addressLine2
    city
    state
    zipCode
    country
    emailAddress
    birthMonth
    birthDay
    birthYear
    spouseFirstName
    spouseMiddleName
    spouseLastName
    spouseBirthMonth
    spouseBirthDay
    spouseBirthYear
    spouseEmailAddress
    spouseId
    spanishMaterial
    accountIndicator
    accountType
    accountStatus
    expiryDate
    autoRenew
    membershipTerm
    cardSentDate
  }
}
`;

export default saveMember;



// WEBPACK FOOTER //
// ./src/app/mutations/saveMember.js